





























































































































import {Component, Prop, Model} from 'vue-property-decorator';
import {Language, InternationalizedField} from '../api/common';
import {MediaFileField} from '../models/fields';
import Hint from '../api/hint';
import Media from '../api/media';
import {BusEvent} from '@/models/bus';
import CommonVue from '../models/commonVue';
import Modal from '@/components/Modal.vue';
import FieldAudio from '@/components/FieldAudio.vue';
import EditIcon from '../components/icons/EditIcon.vue';

@Component({
    components: {
        'modal': Modal,
        'field-audio': FieldAudio,
        'edit-icon': EditIcon,
    },
})
export default class FieldHints extends CommonVue {
    @Model() public hints!: InternationalizedField<Hint[]>;
    @Prop({type: Boolean, default: false}) public disabled?: boolean;


    public languageOptions: object[] = null;
    public language: string = Language.DEFAULT;
    public hint: Hint = null;
    public showModal: boolean = false;

    public beforeMount() {
        this.loadLanguageOptions();
    }
    public mounted() {
        if (this.hints.get(this.language) === undefined) {
            this.hints.set(this.language, []);
        }

    }

    // Loads available languages for selection
    public loadLanguageOptions() {
        this.languageOptions = [];
        for (const option of Language.LIST) {
            this.languageOptions.push({ key: option, flag: Language.flagOf(option), value: option, text: Language.codeOf(option)});
        }
    }

    public newHint() {
        this.hint = new Hint();
        this.hint.language = this.language;
        this.showModal = true;
    }

    public edit(hint: Hint) {
        this.hint = hint;
        this.showModal = true;
    }

    public saveClicked() {
        if (!this.hint) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.hint.state === 'created') {
                if (!this.hints.get(this.language)) {
                    this.hints.set(this.language, []);

                }
                this.hints.get(this.language).push(this.hint);
            }
            this.hint.state = 'updated';
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save hint', e);
        }
    }

    public checkMandatoryFields() {
        // Check if text is filled
        if (!this.hint.text || this.hint.text === '') {
            throw Error('Please insert text for your hint.');
        }

        // Check if audio file was chosen
        // if (!((this.$refs.hint_audio as any) as MediaFileField).hasMedia()) {
        //     throw Error('Please select an audio file.');
        // }
    }

    public deleteClicked() {
        this.hint.state = 'deleted';
        this.showModal = false;
    }

    public static async saveHints(hints: InternationalizedField<Hint[]>, parent_id: number, content_type: string): Promise<void> {
        for (const language of Language.LIST) {
            if (hints.get(language)) {
                for (let hint of hints.get(language)) {
                    if (hint.state === 'updated') {
                        hint.parent_id = parent_id;
                        hint.parent_model = content_type;
                        await FieldHints.saveHint(hint);
                    } else if (hint.state === 'deleted') {
                        hint = new Hint().assign(hint);
                        await hint.delete();
                    }
                }
            }
        }
    }

    public static async saveHint(hint: Hint) {
        if (!hint.id) {
            hint.id = await hint.save();
        }
        await FieldHints.saveMediaFiles(hint);
        hint = new Hint().assign(hint);
        await hint.save();
    }

    public static async saveMediaFiles(hint: Hint) {
        if (hint.audio_file) {
            const audio = await Media.createAudio(
                hint.audio_file,
                Hint.SLUG,
                hint.id,
                'audio_path'
            );
            if (audio !== null) {
                hint.audio = audio;
            }
        } else if (hint.audio_file === null) {
            await Media.deleteAudio(hint.audio);
            hint.audio = undefined;
        }
        if (hint.audio_alt_file) {
            const audio_alt = await Media.createAudio(
                hint.audio_alt_file,
                Hint.SLUG,
                hint.id,
                'audio_alt_path'
            );
            if (audio_alt !== null) {
                hint.audio_alt = audio_alt;
            }
        } else if (hint.audio_alt_file === null) {
            await Media.deleteAudio(hint.audio_alt);
            hint.audio = undefined;
        }
    }
}
